import { cobBusinessTextMessage, isValidCobInvoiceNumber, normalizeCobBusinessText, preventInvalidCobTextInput, preventInvalidCobTextPaste } from "../cobInputValidation";
import { Button, Col, DatePicker, Flex, Input, Row, Select, Space } from 'antd';
import Card from 'antd/es/card/Card';
import dayjs from "dayjs";
import { useState } from 'react';
import { saveCobDenialInvoice as save } from '../../../service/httpsCalls';
import "../billing.scss";

const { Option } = Select;
const { RangePicker } = DatePicker;
interface ClientData {
    id: number,
    name: string
}
interface FilterData extends ClientData {
    clientId: number
}
interface FormFields {
    invoiceClient: any | null,
    invoiceNumber: string | null,
    startDate: string | any,
    endDate: string | any,
    invoiceType: string | null,
    invoiceDate: string | any,
    status: string | any
    pdrCase: string | null,
}

const CreateCOBDenialInvoice = ({ clientList, invoiceTypeLookup, parentCallback, pdrCaseList, closeModal }: any)=> {
    const [form, setForm] = useState<FormFields>({
        invoiceClient: '10',
        invoiceNumber: '',
        startDate: null,
        endDate: '',
        invoiceType: '1',
        invoiceDate: null,
        status: '',
        pdrCase: null,
    });
    const [invoiceTypes, setInvoiceTypes] = useState<FilterData[]>(invoiceTypeLookup.filter((x: any) => x.clientId == '10'));
    const [modalSubmitted, setModalSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    
    function reportInvalidInvoiceText() {
        parentCallback({ isInvalid: true, errorMessage: cobBusinessTextMessage });
    }

    function validateModal() {
        var isValid = true;
        var errorMessage = '';
        setModalSubmitted(true);
        if (!(form.invoiceClient && form.invoiceType && form.pdrCase && form.invoiceNumber && form.startDate && form.endDate && form.invoiceDate)) {
            isValid = false;
            errorMessage = "Please fill required details"
        }
        if (isValid && !isValidCobInvoiceNumber(form.invoiceNumber)) {
            isValid = false;
            errorMessage = cobBusinessTextMessage;
        }
        return { isValid, errorMessage };
    }

    function cancelModal(e?:any) {
        clearModalFields();
        setModalSubmitted(false);
        closeModal()
        if (e) {
            parentCallback({
                isCancel: true
            })
        }
    }

    function saveInvoice() {
        if (validateModal().isValid) {
            setLoading(true)
            save({
                "id": null,
                "clientId": parseInt(form.invoiceClient),
                "invoiceTypeId":  parseInt(form.invoiceType ? form.invoiceType : '1'),
                "invoiceDate": dayjs(form.invoiceDate).format('YYYY-MM-DD'),
                "invoiceNumber": form.invoiceNumber,
                "fromPaymentDate": dayjs(form.startDate).format('YYYY-MM-DD'),
                "toPaymentDate": dayjs(form.endDate).format('YYYY-MM-DD'),
                "pdrCaseId": parseInt(form.pdrCase ? form.pdrCase : '1'),
            }, (res: any) => {
                setLoading(false)
                if (res?.hasError) {
                    const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                    parentCallback({
                        isInvalid: true,
                        errorMessage: errorMsg
                    })
                } else {
                    cancelModal();
                    parentCallback({
                        message: 'Invoice saved successfully!'
                    })
                }
            })
        } else {
            parentCallback({
                isInvalid: true,
                errorMessage: validateModal().errorMessage
            })
        }
    }

    function clearModalFields() {
        setForm({
            ...form,
            invoiceDate: null,
            invoiceNumber: null,
            startDate: null,
            endDate: null,
            invoiceClient: null,
            invoiceType: null,
            status:'', 
            pdrCase: null,
        });
        setInvoiceTypes([]);
    }

    function clientSelected(e: any) {
        if (e) {
            setForm({
                ...form,
                invoiceClient: e,
                invoiceType: '1',
            })
            setInvoiceTypes(invoiceTypeLookup.filter((x: any) => x.clientId == e));
        }
    }

    return (
        <div style={{ paddingTop:'15px' }}>
            <Card styles={{ body: { padding: '15px' } }} loading={loading}>
                <p
                    style={{
                        fontSize: 14,
                        color: 'rgba(0, 0, 0, 0.85)',
                        marginTop: '0px',
                        fontWeight: 500,
                    }}
                >
                    Invoice Information
                </p>
                <div>
                    <Row style={{ paddingBottom: '1rem', background: '#fff' }}>
                        <Col span={6} style={{ paddingRight: '0.5rem' }}>
                            <label>Client</label>
                            <Select
                                style={{ width: '100%' }}
                                placeholder="Select a Client"
                                onChange={(e) => clientSelected(e)}
                                status={modalSubmitted && !form.invoiceClient ? 'error' : ''}
                                value={form.invoiceClient}
                            >
                                {clientList && clientList.map((item: any) => (
                                    <Option key={item.id}>{item.name}</Option>
                                ))}
                            </Select>
                        </Col>
                    </Row>
                    <Row  style={{ paddingBottom: '1rem', background: '#fff' }}>
                        <Col span={6} style={{ paddingRight: '0.5rem' }}>
                            <label>Invoice Type</label>
                            <Select
                                style={{ width: '100%' }}
                                placeholder="Invoice Type"
                                onChange={(e) => setForm({
                                    ...form,
                                    invoiceType: e
                                })}
                                status={modalSubmitted && !form.invoiceType ? 'error' : ''}
                                value={form.invoiceType}
                                disabled={true}
                            >
                                {invoiceTypes && invoiceTypes.map(item => (
                                    <Option key={item.id}>{item.name}</Option>
                                ))}
                            </Select>
                        </Col>
                        <Col span={6} style={{ paddingRight: '0.5rem' }}>
                            <label>PDR Case</label>
                            <Select
                                style={{ width: '100%' }}
                                placeholder="PDR Case"
                                onChange={(e) => setForm({
                                    ...form,
                                    pdrCase: e
                                })}
                                status={modalSubmitted && !form.pdrCase ? 'error' : ''}
                                value={form.pdrCase}
                                disabled={!form.invoiceClient}
                            >
                                {pdrCaseList && pdrCaseList.map((item: any) => (
                                    <Option key={item.id}>{item.name}</Option>
                                ))}
                            </Select>
                        </Col>
                        <Col span={6} style={{ paddingRight: '0.5rem' }}>
                            <label>Invoice #</label>
                            <Input onBeforeInput={event => preventInvalidCobTextInput(event, reportInvalidInvoiceText)} onPaste={event => preventInvalidCobTextPaste(event, reportInvalidInvoiceText)} value={form.invoiceNumber ?? ''} status={modalSubmitted && !isValidCobInvoiceNumber(form.invoiceNumber) ? 'error' : ''} disabled={!form.invoiceClient || !form.invoiceType} placeholder="Invoice #" style={{ width: '100%' }} allowClear
                                maxLength={100}
                                onChange={(e) => {
                                    setForm({
                                        ...form,
                                        invoiceNumber: normalizeCobBusinessText(e.target.value, form.invoiceNumber ?? "", 100, reportInvalidInvoiceText)
                                    })
                                }}
                            />
                        </Col>       
                    </Row>
                    <Row  style={{ paddingBottom: '1rem', background: '#fff' }}>
                        <Col span={6} style={{ paddingRight: '0.5rem' }}>
                            <label>Invoice Date</label>
                            <DatePicker placeholder='Invoice Date' status={modalSubmitted && !form.invoiceDate ? 'error' : ''} value={form.invoiceDate} format="MM/DD/YYYY" disabled={!form.invoiceClient || !form.invoiceType} style={{ width: '100%' }}
                                onChange={(date: any) => {
                                    setForm({
                                        ...form,
                                        invoiceDate: date ? date : ''
                                    })
                                }}
                            />
                        </Col>
                        <Col span={12} style={{ paddingRight: '0.5rem' }}>
                            <label>Payment Date Range</label>
                            <RangePicker style={{ width: '100%' }}
                                format="MM/DD/YYYY"
                                value={[form.startDate, form.endDate]}
                                status={modalSubmitted && !(form.startDate && form.endDate) ? 'error' : ''}
                                disabled={!form.invoiceClient || !form.invoiceType}
                                onChange={(dates: any) => {
                                    if (dates) {
                                        setForm({
                                            ...form,
                                            startDate: dates[0],
                                            endDate: dates[1]
                                        })
                                    } else {
                                        setForm({
                                            ...form,
                                            startDate: '',
                                            endDate: ''
                                        })
                                    }
                                }}
                            />
                        </Col>      
                    </Row>
                        <Flex justify="end">
                            <Space>
                                <Button key="3" onClick={e => cancelModal(e)} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }} type="primary">
                                    Cancel
                                </Button>
                                <Button key="1" onClick={e => saveInvoice()} style={{ backgroundColor: "#ff4d4f", color: "#fff" }}>Save</Button>
                            </Space>
                        </Flex>
                </div>
                
            </Card>        
    </div>
  )
}

export default CreateCOBDenialInvoice;
